import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="developer-credits">
                    Developed by <a href="https://juicycore.gr" target="_blank" rel="noopener noreferrer">JuicyCore</a>
                </p>
                <p className="copyright">
                    © {new Date().getFullYear()} All rights reserved
                </p>
            </div>
        </footer>
    );
};

export default Footer; 